import React, { Component } from 'react';
import { withRouter } from "react-router";
import Wizard from '../../../layouts/Wizard';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import * as apiServices from '../../../services/apiServices';
import { Exercise, ExerciseForm } from '../../../core/model';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import { getResources } from '../../../modules/Resource';
import { setForm } from '../../../modules/ExerciseForm';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import { formatDataToModel } from '../../../utils';
import { toast } from 'react-toastify';

// Components
import EditExerciseForm from '../EditForm';
// import ExerciseSelect from '../ExerciseSelect';

class ExerciseWizard extends Component {
  constructor(props) {
    super(props);
    this.inForm = true;
    this.state = {
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { match, location, getResources, resourceState, setForm } = this.props;
    try {
      const uid = match.params.uid;
      let data = null;
      if(location.state && location.state.exercise) {
        data = location.state.exercise;
      } else if(uid != null) {
        data = await apiServices.getExerciseByUid(uid);
      }
      if(!resourceState.resourceData){
        await getResources();
      }
      const currentExercise = formatDataToModel(data, Exercise);
      const exerciseForm = new ExerciseForm();
      if(currentExercise){
        exerciseForm.formatForForm(currentExercise);
      }
      setForm(exerciseForm, true);
      this.setState({
        isLoading: false,
      });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  cancel = async () => {
    const { history } = this.props;
    history.goBack();
  }

  save = (callback) => {
    const { history, exerciseFormState } = this.props;
    const exerciseForm = exerciseFormState.form;
    this.submitForm(exerciseForm, () => {
      if (callback) {
        callback();
      }
      history.push('/exercises');
    });
  }

  submitForm = (form, callback) => {
    const uid = form.id;

    this.props.setGlobalLoadingSpinner(true, 'updating exercise...');
    apiServices.updateExercise(uid, form.formatforDB())
    .then(response => {
      toast.success(`Successfully updated exercise ${form.name}.`);
      if (callback) {
        callback();
      }
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(
        e.response.data.ValidationError ? e.response.data.ValidationError : e.message
      );
    })
  }

  render() {
    const { isLoading } = this.state;
    const { exerciseFormState, ...other } = this.props;
    return isLoading ? (
      <LoadingSpinnerPage/>
    ) : (
      <Wizard
        clean={exerciseFormState.clean}
        onFinish={this.save}
        onCancel={this.cancel}
        saveText="Save Exercise"
        stepComponents={[
          {
            label: 'Edit Exercise',
            component: <EditExerciseForm exerciseData={exerciseFormState.form} {...other} />,
          },
        ]}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
    exerciseFormState: state.exerciseFormState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    setForm: setForm,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
  }, dispatch)
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ExerciseWizard);
